import log from 'client/lib/log';

export default function getNumbersRange(arrayOfNumberRanges = []) {
  let isRange = true;
  let lowestNumber;
  let highestNumber;

  if (!arrayOfNumberRanges.length) {
    log.error(new Error('getNumbersRange is getting an empty array.'));
  }

  arrayOfNumberRanges.forEach((priceRangeString) => {
    if (priceRangeString.includes('+')) {
      isRange = false;
      if (!lowestNumber || priceRangeString < lowestNumber) {
        lowestNumber = parseInt(priceRangeString, 10);
      }
      if (!highestNumber || priceRangeString > highestNumber) {
        highestNumber = parseInt(priceRangeString, 10);
      }
    } else {
      priceRangeString.split('-').forEach((number) => {
        if (!lowestNumber || number < lowestNumber) {
          lowestNumber = parseInt(number, 10);
        }
        if (!highestNumber || number > highestNumber) {
          highestNumber = parseInt(number, 10);
        }
      });
    }
  });

  return {
    isRange,
    lowestNumber,
    highestNumber,
  };
}
